module.exports = __webpack_public_path__ + "img/face-neutral.20a8c208.svg";